import BaseWidgetProvider from '../../base/BaseWidgetProvider'
import ListIcon from '@mui/icons-material/List'
import PlannedJobListWidget from './PlannedJobListWidget'
import PlannedJobListWidgetConfiguration from './PlannedJobListWidgetConfiguration'
import { DEFAULT_VISIBLE_TABS, DEFAULT_PRIMARY_LIST } from './utils/plannedJobTabs'

/**
 * Provider class for the PlannedJobListWidget.
 * Defines widget metadata and factory method.
 */
class PlannedJobListWidgetProvider extends BaseWidgetProvider {
  getCode = () => 'PlannedJobListWidget'

  getName = () => 'Planned Jobs'

  getIcon = () => ListIcon

  createWidget = (props) => <PlannedJobListWidget {...props} />

  createPreviewWidget = (props) => <PlannedJobListWidget {...props} preview />

  getDefaultConfiguration = () => ({
    hiddenColumns: [],
    // RN10/D5: retrocompatible default -- the 3 existing tabs (no "All Active Jobs") and the
    // widget's own current queue as the main view (not the "All Planned" tab).
    visibleTabs: DEFAULT_VISIBLE_TABS,
    primaryList: DEFAULT_PRIMARY_LIST
  })

  createConfigurationWidget = (data, setData, t_) => (
    <PlannedJobListWidgetConfiguration
      data={data}
      setData={setData}
      t_={t_}
    />
  )

  size = { defaultW: 4, defaultH: 3, minW: 4, minH: 3 }

  getWidgetInfo = (columns, cellHeight) => {
    return { ...super.getWidgetInfo(columns, cellHeight, this.size), hideHeader: true }
  }
}

export default PlannedJobListWidgetProvider
